import Vue from 'vue'
import Router from 'vue-router'
import PlatformSelection from '../views/PlatformSelection.vue'
import Login from '../views/Login.vue'
import Users from '../views/Users.vue'
import Classes from '../views/Classes.vue'
import Cases from '../views/Cases.vue'
import MapTemplates from '../views/MapTemplates.vue'
import MapTemplateLibrary from '../views/MapTemplateLibrary.vue'
import Personnel from '../views/Personnel.vue'
import Experiments from '../views/Experiments.vue'
import Assignments from '../views/Assignments.vue'
import NetworkRun from '../views/NetworkRun.vue'
import PolicyRun from '../views/PolicyRun.vue'
import Reports from '../views/Reports.vue'
import Notifications from '../views/Notifications.vue'
import Profile from '../views/Profile.vue'
import OperationLogs from '../views/OperationLogs.vue'
import Backups from '../views/Backups.vue'
import RoleStandards from '../views/RoleStandards.vue'
import TaskMonitor from '../views/TaskMonitor.vue'
import CaseWorkbench from '../views/CaseWorkbench.vue'
import RoleGuide from '../views/RoleGuide.vue'
import RolePermissions from '../views/RolePermissions.vue'
import NetworkModules from '../views/NetworkModules.vue'
import NetworkModuleCreate from '../views/NetworkModuleCreate.vue'
import NetworkModuleAi from '../views/NetworkModuleAi.vue'

import store from '../store'
import { additionalRoutePermissions, can, routePermission } from '../services/permissions'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/login', name: 'login', component: Login },
    {
      path: '/',
      name: 'home',
      component: PlatformSelection
    },
    { path: '/users', name: 'users', component: Users, meta: { roles: ['ADMIN', 'TEACHER'] } },
    { path: '/classes', name: 'classes', component: Classes, meta: { roles: ['ADMIN', 'TEACHER'] } },
    { path: '/cases', name: 'cases', component: Cases },
    { path: '/cases/:caseId/configure', name: 'case-workbench', component: CaseWorkbench, meta: { roles: ['ADMIN', 'TEACHER'] } },
    { path: '/map-templates', name: 'map-templates', component: MapTemplateLibrary, meta: { roles: ['ADMIN', 'TEACHER'], menu: 'city-maps' } },
    { path: '/map-templates/:templateId', name: 'map-template-detail', component: MapTemplates, meta: { roles: ['ADMIN', 'TEACHER'], menu: 'city-maps' } },
    { path: '/network/modules', name: 'network-modules', component: NetworkModules, meta: { roles: ['ADMIN', 'TEACHER'], menu: 'city-custom' } },
    { path: '/network/modules/new', name: 'network-module-create', component: NetworkModuleCreate, meta: { roles: ['ADMIN', 'TEACHER'], menu: 'city-custom' } },
    { path: '/network/modules/ai', name: 'network-module-ai', component: NetworkModuleAi, meta: { roles: ['ADMIN', 'TEACHER'], menu: 'city-custom' } },
    { path: '/network/modules/:moduleId', name: 'network-module-edit', component: NetworkModules, meta: { roles: ['ADMIN', 'TEACHER'], menu: 'city-custom' } },
    { path: '/personnel', name: 'personnel', component: Personnel, meta: { roles: ['ADMIN', 'TEACHER'], menu: 'city-maps' } },
    { path: '/role-standards', name: 'role-standards', component: RoleStandards, meta: { roles: ['ADMIN', 'TEACHER'], menu: 'city-maps' } },
    { path: '/experiments', name: 'experiments', component: Experiments, meta: { roles: ['ADMIN', 'TEACHER'] } },
    { path: '/task-monitor', name: 'task-monitor', component: TaskMonitor, meta: { roles: ['ADMIN', 'TEACHER'] } },
    { path: '/assignments', name: 'assignments', component: Assignments },
    { path: '/network/runs/:runId', name: 'network-run', component: NetworkRun, meta: { menu: 'student-city-run' } },
    { path: '/policy/runs/:runId', name: 'policy-run', component: PolicyRun },
    { path: '/reports', name: 'reports', component: Reports },
    { path: '/notifications', name: 'notifications', component: Notifications },
    { path: '/profile', name: 'profile', component: Profile },
    { path: '/role-guide', name: 'role-guide', component: RoleGuide },
    { path: '/logs', name: 'logs', component: OperationLogs, meta: { roles: ['ADMIN'] } },
    { path: '/backups', name: 'backups', component: Backups, meta: { roles: ['ADMIN'] } },
    { path: '/role-permissions', name: 'role-permissions', component: RolePermissions, meta: { roles: ['ADMIN'] } },
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach(async (to, from, next) => {
  const token = window.localStorage.getItem('sandbox.token')
  const user = JSON.parse(window.localStorage.getItem('sandbox.user') || 'null')
  if (to.name === 'login') {
    return token && user ? next('/') : next()
  }
  if (!token || !user) return next('/login')
  try {
    const current = await store.dispatch('refreshCurrentUser')
    if (current.role === 'STUDENT' && Array.isArray(to.meta.roles) && !to.meta.roles.includes('STUDENT')) return next('/')
    const required = routePermission(to)
    if (to.name !== 'home' && required && !can(current, required)) return next('/')
    if (additionalRoutePermissions(to).some(code => !can(current, code))) return next('/')
  } catch (error) { if ([401, 403].includes(error.response?.status)) { store.commit('clearAuth'); return next('/login') } return next(false) }
  next()
})

export default router
